import { BsData } from "../models/ExchBetSlip";
import SAP_API from "../services/sap";
import store from "../store/store";
import { clearExchangeBets, setBettingInprogress } from "../store/exchBetSlip/exchBetSlipReducer";
import { toast } from "react-toastify";
import { getUserBalance } from "../store/authActions";
import { fetchOpenBets } from "../store/exchBetSlip/exchBetSlipAction";

export const getBetStatus = async (data: BsData, dispatch: Function, navigate?: Function) => {
  dispatch(setBettingInprogress(true));
  
  // Determine which data to use based on the origin
  const state = store.getState();
  const authData = data.origin === "SPORTSBOOK" ? state.userDetails.sbData : state.userDetails.exchData;
  
  const payload = {
    eventId: data.eventId,
    partnerId: authData?.partnerId,
    operatorId: authData?.operatorId,
    providerId: authData?.providerId,
    sportId: data.sportId,
    token: authData?.token,
  };

  const startTime = Date.now();
  const maxDuration = 60000; // 1 minute in milliseconds

  while (1) {
    // Check if we've exceeded the maximum duration
    if (Date.now() - startTime > maxDuration) {
      dispatch(setBettingInprogress(false));
      toast.error("timed out");
      return false;
    }
    const res: any = await SAP_API.post("/core/userbet-status", payload);
    if (["BETTING_IN_PROGRESS", "PENDING"].includes(res.data.betStatus)) {
      await new Promise(resolve => setTimeout(resolve, 300));
      continue;
    } else if (
      res.data.status === "RS_OK" &&
      ["CANCELLED", "EXPIRED", "FAILED"].includes(res.data.betStatus)
    ) {
      dispatch(setBettingInprogress(false));
      toast.error(
        res.data.betErrorMsg
          ? res.data.betErrorMsg
          : "Bet is not placed, try again");
      return false;
    } else if (res.data?.betStatus === "COMPLETED") {
      dispatch(setBettingInprogress(false));
      dispatch(clearExchangeBets({}));
      dispatch(getUserBalance());
      dispatch(fetchOpenBets(data.eventId, data.sportId));
      toast.success(
        res.data.errorDescription
          ? res.data.errorDescription
          : "Bet placed successfully.");
      return true;
    }
  }
};

export const placeBet = async (data: BsData, dispatch: Function, getBetStatusCallback?: Function, navigate?: Function) => {
  try {
    // Validate stake amount
    if (data.stakeAmount < 1) {
      toast.error("Minimum stake amount required.");
      return false;
    }

    if (
      (data?.minLimit !== 0 && data?.minLimit > data.stakeAmount) ||
      (data?.maxLimit !== 0 && data?.maxLimit < data.stakeAmount)
    ) {
      toast.error("Total stake should not be less than " + data?.minLimit + " and should not exceed " + data?.maxLimit);
      return false;
    }

    if (!data.oddValue) {
      toast.error("Invalid odds");
      return false;
    }

    dispatch(setBettingInprogress(true));
    
    // Determine which data to use based on the origin
    const state = store.getState();
    const authData = data.origin === "SPORTSBOOK" ? state.userDetails.sbData : state.userDetails.exchData;

    const payload = {
      token: authData?.token,
      partnerId: authData?.partnerId,
      operatorId: authData?.operatorId,
      providerId: data.provider,
      sportId: data.sportId,
      competitionId: data.competitionId,
      eventId: data.eventId,
      betType: data.betType,
      oddValue: data.oddValue,
      stakeAmount: data?.stakeAmount,
      marketType: data.marketType,
      marketName: data.marketName,
      marketId: data.marketId,
      runnerId: data.runnerId,
      runnerName: data.runnerName,
      sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
      origin: data.origin === "SPORTSBOOK" ? "SPORTSBOOK" : "EXCHANGE"
    };

    const res: any = await SAP_API.post("/core/sportsbet", payload);

    if (res.data.status === "") {
      dispatch(setBettingInprogress(false));
      toast.error(res.data?.errorDescription);
      return false;
    } else if (res.data.status === "RS_OK") {
      if (res.data.betId && !res.data.errorDescription) {
        // Call getBetStatus if callback is provided
        if (getBetStatusCallback) {
          return getBetStatusCallback(data);
        } else {
          dispatch(setBettingInprogress(false));
          dispatch(clearExchangeBets({}));
          return true;
        }
      } else {
        dispatch(setBettingInprogress(false));
        toast.success(res.data?.errorDescription);
        dispatch(clearExchangeBets({}));
        return true;
      }
    }
  } catch (e) {
    dispatch(setBettingInprogress(false));
    toast.error("Something went wrong, try again");
    return false;
  }
};
